export const STATUS_NEW = 1;
export const STATUS_WORK = 2;
export const STATUS_REJECTED = 3;
export const STATUS_DONE = 4;
